import React from 'react';

/** HAAT logo URL */
const LOGO_URL = 'https://cdn.prod.website-files.com/6829acf870093a50cc6ceb69/682b03419ead6e45d8f2c59e_logo%20(2).svg';

interface HeaderLogoProps {
  /** Show text next to logo */
  showText?: boolean;
}

/**
 * HeaderLogo Component
 * 
 * HAAT Hub logo with optional text.
 * Used in headers across the application.
 * 
 * @example
 * <HeaderLogo showText />
 */
const HeaderLogo: React.FC<HeaderLogoProps> = ({ showText = true }) => {
  return (
    <div className="flex items-center gap-3">
      <div className="inline-flex items-center justify-center w-20 h-20">
        <img
          src={LOGO_URL}
          alt="HAAT Hub Logo"
          className="w-full h-full object-contain"
          loading="eager"
        />
      </div>
      {showText && (
        <div>
          <h1 className="text-lg font-rubik font-bold text-haat-dark">
            HAAT Hub
          </h1>
          <p className="text-xs text-haat-gray-light">
            Enterprise Portal prod
          </p>
        </div>
      )}
    </div>
  );
};

export default HeaderLogo;

